import {GetterTree, Module, MutationTree} from "vuex";

export class AppYnState {
  constructor(appYn: string | null) {
    if (appYn) {
      this.appYn = appYn;
    }
  }
  public appYn?: string;
}

const getters: GetterTree<AppYnState, any> = {
  isApp(state: AppYnState): boolean {
    return state.appYn === 'Y';
  },
};

const mutations: MutationTree<AppYnState> = {
  setAppYn(state: AppYnState, appYn: string): void {
    if (appYn) {
      sessionStorage.setItem('appYn', appYn);
      state.appYn = appYn;
    }
  },
};

export const AppYnStore: Module<AppYnState, any> = {
  namespaced: true,
  state: new AppYnState(sessionStorage.getItem('appYn')),
  getters,
  mutations,
};